import { render } from "./EnquiryForm.vue?vue&type=template&id=12a1fc70"
import script from "./EnquiryForm.vue?vue&type=script&lang=js"
export * from "./EnquiryForm.vue?vue&type=script&lang=js"

import "./EnquiryForm.vue?vue&type=style&index=0&id=12a1fc70&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__